import { useEffect, useState } from "react"
import { getStorageValue, onStorageChange, setStorageValue } from "./storage"
import type { Jsonable } from "@/utils"

export default <S extends Jsonable>(key: string, initialState: S) => {
  const [value, setValue] = useState<S>(
    () => getStorageValue<S>(key) ?? initialState,
  )

  // Read from storage
  useEffect(() => onStorageChange<S>(key, setValue), [key])

  // Write to storage
  useEffect(() => {
    setStorageValue(key, value)
  }, [key, value])

  return [value, setValue] as const
}
